import { QueryClient, useQuery } from "@tanstack/react-query";
import { fetchRegistryData } from "../api/serviceRegistryApi";

const registryQueryClient = new QueryClient();

export const useRegistryData = () =>
  useQuery(
    {
      queryKey: ["service-registry"],
      queryFn: fetchRegistryData,
      retry: false,
    },
    registryQueryClient,
  );
